import { PayloadAction } from "@reduxjs/toolkit";
import { getTimeOffs_timeOffs_timeOffs } from "../../../../__generated/getTimeOffs";
import { LeavesState } from "../leavesSlice";

const leaveEdited = (
  state: LeavesState,
  { payload }: PayloadAction<getTimeOffs_timeOffs_timeOffs>
) => {
  state.timeOffs.forEach((timeOff, index) => {
    if (timeOff.id === payload.id) {
      state.timeOffs[index] = payload;
    }
  });

  if (state.selectedTimeOff?.id === payload.id) {
    state.selectedTimeOff = payload;
  }
};

export default leaveEdited;
